<script>
  import LocalizacaoService from '../../../../domain/policia-civil/localizacao/services/localizacao'
  import AtendentePatioService from '../../../../domain/policia-civil/atendente-patio/services/atendente-patio'
  import GrvService from '../../../../domain/grv/services/index'
  import {fileToBase64} from '../../../_default/utils/fileToBase64'
  import { isArray, debounce } from 'lodash'

  let templateArquivo = {id: null, nomeArquivo: null, nomeOriginal: null, descricao: null, tipo: null, arquivo: null}

  export default {
    components: {},
    nome: 'localizacao-veiculo',
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          grv: null,
          atendente: null,
          vaga: null,
          arquivos: []
        },
        patio: null,
        atendentes: [],
        listaGrvs: [],
        patios: [],
        filtroInput: {
          id: null,
          titulo: ''
        },
        showOptionsAutocomplete: false,
        loading: false,
        formdataFotosParaUpload: []

      }
    },
    computed: {
      patiosComputed () {
        return this.patios.map((v) => {
          return {label: v.nome, value: v.id}
        })
      }
    },
    created () {
      this.carregarPatios()
      this.carregarAtendente()
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      carregarPatios () {
        AtendentePatioService.patios()
        .then(response => {
          this.patios = response.data.patios
        })
        .catch(error => {
          console.log(error)
          alert('Erro ao carregar a lista de leilões')
        })
      },
      carregarAtendente () {
        this.$loaderOverlay.open().message('Carregando')
        AtendentePatioService.list(200, 1, '&busca=')
        .then((response) => {
          console.log(response.data)
          this.atendentes = response.data.result
          this.isLoaded = true
          this.$loaderOverlay.hide()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
      },
      start () {
        this.isLoaded = true
        this.$nextTick(() => {
          this.$refs.grv.disabled = true
        })
      },
      uploadFoto: async function (e) {
        for (let file of e.target.files) {
          this.data.arquivos.push(JSON.parse(JSON.stringify(templateArquivo)))
          const data = await fileToBase64(file)
          const lastPosition = this.data.arquivos.length - 1
          this.data.arquivos[lastPosition].nomeArquivo = file.name
          this.data.arquivos[lastPosition].nomeOriginal = file.name
          this.data.arquivos[lastPosition].tipo = file.name.split('.').pop()
          this.data.arquivos[lastPosition].arquivo = data
          this.data.arquivos[lastPosition].fromCelular = true
        }
      },
      openMultipleInputFile (inputRef) {
        this.$refs[inputRef].click()
      },
      excluirFoto (index) {
        this.$delete(this.data.arquivos, index)
      },
      selectedPatio () {
        if (this.patio) {
          this.filtroInput.titulo = ''
          this.$refs.grv.disabled = false
        } else {
          this.$refs.grv.disabled = true
        }
      },
      submit () {
        /* eslint-disable */

        const data = JSON.parse(JSON.stringify(this.data))
        const {id} = this.filtroInput
        if (!id) {
          let {id, titulo} = this.filtroInput
          if (id !== 0 && !id) {
            const regex = new RegExp(`^${titulo.toLowerCase()}$`)
            const match = this.listaGrvs.filter(item => {
              return item.placa.toLowerCase().match(regex) || item.numero.toLowerCase().match(regex)
            })
            if (match.length) {
              data.grv = match[0].id
            } else {
              alert('Grv não encontrada')
              this.$loaderOverlay.hide()
              return
            }
          }
        } else {
          data.grv = id
        }

        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        console.log(data)
        LocalizacaoService.cadastrar(data).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      getListaGrvs: debounce(function () {
        this.listaGrvs = []
        this.filtroInput.id = null
        this.loading = true
        const filtro = this.filtroInput.titulo.split(' - ')[0]
        if (filtro) {
          this.setVisibilityOptionsAutocomplete(true)
          GrvService.listaSimples(this.filtroInput.titulo, this.patio)
            .then(result => {
              this.listaGrvs = result.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
              alert('Erro ao carregar lista de grvs')
              this.loading = false
            })
        } else {
          this.loading = false
          this.setVisibilityOptionsAutocomplete(false)
        }
      }, 300),
      setFiltroInput (filtro) {
        this.filtroInput = {...filtro}
        this.filtroInput.titulo = `${filtro.numero} - ${filtro.placa}`
      },
      setVisibilityOptionsAutocomplete (status) {
        setTimeout(() => {
          this.showOptionsAutocomplete = status
        }, 100)
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Localização de Veículo</h1></div>
          <div class="col-sm-6">
            <!--<router-link :to="{name: 'config.estado-veiculo.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>-->
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent="submit" class="bs-example form-horizontal">
              <div class="form-group">
                <label for="patio" class="col-sm-4 control-label">Patio</label>
                <div class="col-sm-4">
                   <select class="form-control"  v-model="patio" @change="selectedPatio" title="Não selecione caso não queira uma filtragem por pátio" required>
                    <option style="font-weight: bold" :value="null">Selecione um patio</option>
                    <option v-for="cat in patiosComputed" :value="cat.value">{{cat.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">GRV</label>
                <div class="col-sm-8">
                  <!-----------TODO: Componente separado---------------------------------------->
                  <div class="autocomplete-input">
                    <input class="form-control" type="text" @blur="setVisibilityOptionsAutocomplete(false)" @keyup="getListaGrvs" v-model="filtroInput.titulo" ref="grv" placeholder="Placa ou número da GRV">
                    <ul class="list-group" v-show="showOptionsAutocomplete">
                      <li class="text-center" v-if="loading"><i class="fa fa-spinner fa-spin"></i></li>
                      <li class="text-danger" v-else-if="!listaGrvs.length">Grv não encontrada</li>
                      <li @click="setFiltroInput(item)" v-for="item in listaGrvs" :key="item.id" v-else>{{item.numero}} - {{item.placa}}</li>
                    </ul>
                  </div>

                  <!---------------------------------------------------------------------------->
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Atendente</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.atendente" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="atendente.id" v-for="atendente in atendentes" :key="atendente.id">{{atendente.nome}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Vaga</label>
                <div class="col-sm-8">
                  <input id="vaga" v-model="data.vaga" type="text" class="form-control"/>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h2 class="font-thin h3">
                          Fotos do veículo
                        </h2>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered table-striped b-t b-light">
                      <thead>
                      <tr>
                        <th colspan="1">Descrição</th>
                        <th>Foto</th>
                        <th>Tipo arquivo</th>
                        <td>Excluir</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(arquivo, index) in data.arquivos">
                        <td scope="row"><input :id="'arquivo-desc'+index" v-model="arquivo.descricao" type="text"
                                               class="form-control"/></td>
                        <td scope="row" style="position: relative; display: flex; justify-content: center; align-items: center;">
                          <a>
                            <img :src="arquivo.imageInfo && (arquivo.imageInfo.thumb ? arquivo.imageInfo.thumb : arquivo.imageInfo.full)['url'] || arquivo.arquivo || arquivo.thumb || ''" alt="foto-veiculo" class="img-preview" v-if="arquivo.tipo !== 3" loading="lazy">
                            <span v-else>Ver assinatura</span>
                          </a>
                        </td>
                        <td scope="row">
                          <div>
                            <span>.{{arquivo.tipo}}</span>
                          </div>
                        </td>
                        <td scope="row">
                          <label class="i-checks m-b-none">
                           <button type="button" @click="excluirFoto(index)" :value="index" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                          </label>
                        </td>
                      </tr>
                      <tr v-if="!data.arquivos || data.arquivos.length === 0">
                        <td colspan="4">Nenhum arquivo nesta GRV</td>
                      </tr>
                      </tbody>
                    </table>
                    <br>
                    <div class="wrapper-sm m-t-n m-b">
                      <input type="file" name="files[]" id="fileInptImg" multiple ref="fileInptImg" @change="uploadFoto" v-show="false" accept="image/*">
                      <!-- <input type="file" name="files[]" id="fileInptImgCelular" multiple ref="fileInptImgCelular" @change="uploadDocumentoPeloCelular" v-show="false" accept="image/*"> -->
                      <!--<button @click="adicionarArquivo" type="button" class="btn btn-info btn-md m-l-xs btn-colsultaGrv">
                        Adicionar arquivo
                      </button>-->
                      <!--TODO: talvez deixar somente a lógica pelo celular mesmmo; temporáriamente ambos utilizarão a lógica de envio pelo celular, por emergência-->
                      <button @click="openMultipleInputFile('fileInptImg')" type="button" class="btn btn-info btn-md m-l-xs btn-colsultaGrv btnPicDesktop">
                       Adicionar&nbsp;<i class="fa fa-picture-o"></i>
                      </button>
                      <br>
                      <small>* Você pode selecionar mais de uma foto ao mesmo tempo para enviar</small>
                    </div>
                  </div>
              <hr>
              <div class="row wrapper">
                <u-button class="btn m-b-xs w-xs btn-info m-r-xs" type="submit">
                  <span>Salvar</span>
                </u-button>
                <!--<u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.estado-veiculos.list'})">Cancelar</u-button>-->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  /* Raphael */
  .autocomplete-input {
    position: relative;
  }
  .autocomplete-input input {
    width: 100%;
    height: 100%;
  }
  .autocomplete-input ul {
    position: absolute;
    border: #999 1px solid;
    list-style-type: none;
    width: 100%;
    max-height: 80px;
    overflow: auto;
    background-color: #fff;
    z-index: 99;
  }
  .autocomplete-input ul li {
    padding: 5px;
    cursor: pointer;
  }
  .autocomplete-input ul li:hover {
    background-color: #fff;
    color: #333;
  }
   .img-preview {
    max-height: 183px;
    max-width: 100px;
  }
  .img-preview-placeholder {
    position: absolute;
    opacity: 0;
    height: 100%;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .img-preview-placeholder:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, .6)
  }
  /* .btnPicMobile {
    display: none;
  }
  @media screen and (max-width: 768px) { 
    .btnPicMobile {
      display: block;
    }
    .btnPicDesktop {
      display: none;
    }
  } */
</style>



// WEBPACK FOOTER //
// LocalizacaoVeiculo.vue?21634d43